import { LabeledSwitch } from '@components/switch';
import { useScopedTranslate } from '@locale/translate';

type Props = {
  value: boolean;
  onChange(value: boolean): void;
};

export const ConfirmationSwitch = ({ value, onChange }: Props) => {
  const { t } = useScopedTranslate(locale);

  return (
    <LabeledSwitch
      label={t('label')}
      helpText={t('confirmationHelpText')}
      onText={t('enable')}
      offText={t('disable')}
      onChange={onChange}
      value={value}
    />
  );
};

const locale = {
  en: {
    label: 'Confirmation',
    confirmationHelpText: '(Displayed twice and has to match)',
    enable: 'Enabled',
    disable: 'Disabled',
  },
};
